<template>
  <div class="loading-spinner">
    <div
      class="loading-spinner__box"
      role="img"
      :aria-label="label"
    >
      <svg
        class="loading-spinner__svg"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="-45 -50 187 234"
      >
        <g class="loading-spinner__group">
          <path
            class="loading-spinner__path loading-spinner__path--a"
            d="M15.5451 88.2688C17.6099 92.9474 21.9989 93.5815 25.3027 89.681L95.2382 7.09955C98.5419 3.19912 97.0629 0 91.9441 0H46.2968C41.1875 0 34.3015 3.18951 30.9978 7.09955L3.31935 39.8113C0.0156069 43.7213 -0.992802 50.744 1.07204 55.4226L15.5547 88.2688H15.5451Z"
            fill="#FFCC00"
          />
          <path
            class="loading-spinner__path loading-spinner__path--b"
            d="M81.4458 45.4783C79.3809 40.7997 74.992 40.1656 71.6882 44.066L1.76229 126.657C-1.54144 130.558 -0.062445 133.757 5.04683 133.757H50.6941C55.8034 133.757 62.6894 130.558 65.9931 126.657L93.6715 93.9358C96.9753 90.0354 97.9837 83.0127 95.9285 78.3341L81.4458 45.4879V45.4783Z"
            fill="#FFCC00"
          />
          <circle
            class="loading-spinner__circle"
            cx="47"
            cy="65"
            r="50"
            fill="#FFCC00"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
  withDefaults(defineProps<{
    label?: string;
  }>(), {
    label: 'Loading',
  });
</script>
